import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { BranchBase } from './branchBase.js';
import * as R from 'ramda';
import { CustomBranch } from './customBranch';

export const BranchService = ({ connectionType, title, generateRelocationLetters }) => {
	const [resetPage, setResetPage] = useState(false);
	const bottomRef = useRef(null);
	const services = useSelector((state) => state.services);
	const [branches, setBranches] = useState({ items: [] });
	const [showCustomBox, setShowCustomBox] = useState(false);
	const [canCollapse, setCanCollapse] = useState(false);
	const [addedNew, setAddedNew] = useState(false);
	const serviceVector = services.serviceData[connectionType];
	const [allBranches, setAllBranches] = useState([]);

	function removeBranch(serviceId) {
		let tmpItems = branches.items.filter((b) => (!R.isNil(serviceId) && !R.isNil(b) ? serviceId !== b.serviceId : !R.isNil(b)));
		setBranches({ ...branches, items: tmpItems });
		if (tmpItems.length === 0) {
			setResetPage(true);
		}
	}

	useEffect(() => {
		if (!R.isNil(connectionType)) {
			let servicesInState = !R.isNil(services) && !R.isNil(services.serviceData) && !R.isNil(services.serviceData[connectionType]) ? services.serviceData[connectionType] : [];
			if (servicesInState.length > 0) {
				setBranches({ items: servicesInState });
			} else {
				setBranches({ ...branches, items: [] });
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [services.serviceData, serviceVector]);

	useEffect(() => {
		if (!R.isNil(connectionType)) {
			setCanCollapse(false);
			setAddedNew(false);
			setShowCustomBox(false);
			setResetPage(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [connectionType]);

	useEffect(() => {
		setTimeout(() => {
			setResetPage(false);
		}, 1);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [resetPage]);

	useEffect(() => {
		if (addedNew === true && !R.isNil(bottomRef) && !R.isNil(bottomRef.current)) {
			bottomRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
		}
		setAddedNew(false);
	}, [addedNew]);

	useEffect(() => {
		let tmpAllServiceDatas = [];
		let allServiceDatasIdList = [];
		if (!R.isNil(services.serviceData[connectionType])) {
			branches.items
				.filter((br) => R.isNil(br) || !R.isNil(br.serviceId))
				.forEach((srv) => {
					if (R.isNil(srv) || !allServiceDatasIdList.includes(srv.serviceId)) {
						tmpAllServiceDatas.push(srv);
						if (!R.isNil(srv)) {
							allServiceDatasIdList.push(srv.serviceId);
						}
					}
				});
		}
		let notNullServicesLength = tmpAllServiceDatas.filter((b) => !R.isNil(b)).length;

		let lastPosition =
			notNullServicesLength !== 0
				? R.reduce(
						R.max,
						-Infinity,
						tmpAllServiceDatas.filter((s) => !R.isNil(s)).map((s) => s.position)
				  ) + 1
				: 0;
		let tmpAllBranches = [];
		let index = 0;
		let firstElement = !R.isNil(services) && !R.isNil(services.serviceData) && !R.isNil(services.serviceData[connectionType]) && services.serviceData[connectionType].length > 0 ? services.serviceData[connectionType][0] : undefined;


		tmpAllServiceDatas.length > 0 &&
			tmpAllServiceDatas.forEach((sData) => {
				let tmpPosition = R.isNil(sData) ? lastPosition : sData.position;
				let isMain = R.isNil(sData) || R.isNil(firstElement) ? notNullServicesLength === 0 : tmpPosition === firstElement.position;
				if (!R.isNil(sData) && sData.serviceId.toLowerCase().startsWith("custom")) {
					tmpAllBranches.push({
						pos: tmpPosition,
						data: (
							<CustomBranch
								title={title}
								isMain={isMain}
								removeBranch={removeBranch}
								key={"custom" + index}
								boxIndex={"custom" + index}
								connectionType={connectionType}
								customServiceData={sData}
								setShowCustomBox={setShowCustomBox}
								totalBranches={tmpAllServiceDatas.length}
								canCollapse={canCollapse}
								generateRelocationLetters={generateRelocationLetters}
							/>
						),
					});
				} else {
					tmpAllBranches.push({
						pos: tmpPosition,
						data: (
							<BranchBase
								isMain={isMain}
								bottomRef={index === tmpAllServiceDatas.length - 1 ? bottomRef : undefined}
								removeBranch={removeBranch}
								canCollapse={canCollapse}
								title={title}
								connectionType={connectionType}
								key={index}
								index={index}
								branch={sData}
								totalBranches={tmpAllServiceDatas.length}
								setShowCustomBox={setShowCustomBox}
								generateRelocationLetters={generateRelocationLetters}
							/>
						),
					});
				}
				index++;
			});

		if (tmpAllBranches.length === 0 && showCustomBox === false) {
			tmpAllBranches.push({
				pos: 0,
				data: (
					<BranchBase
						removeBranch={removeBranch}
						canCollapse={canCollapse}
						title={title}
						isMain={true}
						connectionType={connectionType}
						key="default-branch"
						index={index}
						totalBranches={tmpAllServiceDatas.length}
						setShowCustomBox={setShowCustomBox}
						generateRelocationLetters={generateRelocationLetters}
					/>
				),
			});
		}
		setAllBranches(tmpAllBranches);
	}, [branches, branches.items, branches.items.length, canCollapse, connectionType, services, showCustomBox, title]);

	return (
		<article className="block" id={title}>
			<h3 className="sr-only visually-hidden">{title}</h3>
			{resetPage === false && R.sortWith([R.ascend(R.prop("pos"))])(allBranches).map((b, idx) => React.cloneElement(b.data, { key: `branch-${idx}-${b.pos}` }))}
			{showCustomBox ? <CustomBranch title={title} removeBranch={removeBranch} key={"custom"} boxIndex={branches.items.length} isMain={branches.items.length === 0} connectionType={connectionType} customServiceData={null} setShowCustomBox={setShowCustomBox} generateRelocationLetters={generateRelocationLetters} /> : ""}

			<footer className="block sticky-auto b-auto-0 z-2 mx-auto text-center bg-light pt-4 pb-1">
				<h4 className="sr-only visually-hidden">Add new</h4>
				<button
					type="button"
					className="btn btn-icon btn-alert-info mx-auto py-2"
					disabled={R.isNil(branches.items[branches.items.length - 1]) || showCustomBox}
					onClick={(e) => {
						const nodes = window.document.querySelectorAll(".collapse.show");
						if (!R.isNil(nodes) && nodes.length > 0) {
							nodes.forEach((element) => {
								element.classList.remove(["show"]);
							});
						}
						e.preventDefault();
						setCanCollapse(true);
						setBranches({ ...branches, items: branches.items.concat(undefined) });
						setAddedNew(true);
					}}>
					<i className="eva eva-person-add-outline h3 my-auto mr-2"></i>Ajouter un autre {title.toUpperCase()}
				</button>
			</footer>
		</article>
	);
};